module.exports = {
    encode: require('./encode.js')
  , decode: require('./decode.js')
  , encodingLength: require('./length.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/varint/index.js
// module id = 14
// module chunks = 0